import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import Switch from 'components/ui/Switch';
import COLOR from 'constants/color';
import { Drum } from 'assets/icons/revamp';
import Card from 'components/ui/Card';
import { t } from 'services/i18n.service';
import { updateMoreOptionShowSavedDistractingWebsites } from 'store/reducer/modal/slice';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';

const GuiltFreePlay: React.FC = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);

  const handleToggleGuiltFreePlay = (checked: boolean) => {
    dispatch(updateMoreOptionShowSavedDistractingWebsites(checked));
  };

  return (
    <Card className='flex flex-col ~gap-1/2'>
      <div className='flex items-center ~gap-3/6'>
        <h3 className='~text-xs/base font-semibold flex items-center ~gap-1/2'>
          <Drum styles='~w-4/5 ~h-4/5' fill={COLOR.PRIMARY.LIGHT_900} />
          {t('tabs_revamp.allowed_apps_tab.show_guilt_free_play_popup')}
        </h3>
        <Switch
          checked={activity?.show_saved_distracting_websites ?? false}
          onChange={handleToggleGuiltFreePlay}
          size='medium'
          variant='default'
        />
      </div>
      <p className='~text-xs/sm text-gray-600 dark:text-gray-400 ~ml-0/0'>
        {t(
          'tabs_revamp.allowed_apps_tab.show_guilt_free_play_popup_description'
        )}
      </p>
    </Card>
  );
};

export default GuiltFreePlay;
